<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Expéditions</span>
        <el-button type="primary" size="mini" @click="openForm"
          >Nouvelle expédition</el-button
        >
      </div>

      <shipment-form
        v-if="showForm"
        :shippable-id="shippableId"
        :shippable-type="shippableType"
        @created="reloadShipments"
        @cancel="showForm = false"
      />

      <shipment-list
        v-if="shipments.length"
        :shipments="shipments"
        @updated="reloadShipments"
      />
    </el-card>

  </div>
</template>

<script>
import ShipmentList from "./components/shipments/ShipmentList.vue";
import ShipmentsList from "./Admin/ShipmentsList.vue";
import ShipmentForm from "./components/shipments/ShipmentForm.vue";
import { Form, FormItem, Card, Button, Select, Option, Divider } from "element-ui";

export default {
  name: "ShipmentManager",
  components: { 
    ShipmentList, ShipmentForm, ShipmentsList,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Divider.name]: Divider,
    [Card.name]: Card,
   },
  props: {
    shippableId: { type: [String, Number], required: true },
    shippableType: { type: String, required: true },
  },
  data() {
    return {
      shipments: [],
      showForm: false,
    };
  },
  mounted() {
    this.reloadShipments();
  },
  methods: {
    async reloadShipments() {
      const response = await this.$store.dispatch(
        "elixioConnectModule/getShipments",
        {
          shippableType: this.shippableType,
          shippableId: this.shippableId,
        }
      );
      this.shipments = response ?? [];
      this.showForm = false;
    },

    openForm() {
      this.showForm = true;
    },
  },
};
</script>
